module.exports = __webpack_public_path__ + "img/jinhui.12ef8e2b.png";